import type { TagElementType } from '@/components/Atoms/Tags/Tags';

const sortTags = (a: TagElementType, b: TagElementType) =>
  a.tagKey && b.tagKey ? a.tagKey.localeCompare(b.tagKey) : 0;

export const getOrganisedTags = (
  recievedTags: TagElementType[]
): TagElementType[] => {
  const tags = recievedTags.filter(({ value }) => value);

  const sharedTags = tags
    .filter(({ type }) => type === 'shared_tags')
    .sort(sortTags);

  const userTags = tags
    .filter(({ type }) => type === 'user_tags')
    .sort(sortTags);

  const systemTags = tags
    .filter(({ type }) => type === undefined)
    .sort(sortTags);

  let outerSharedTagsCount = 2;
  let outerUserTagsCount = 2;

  if (userTags.length < 2) {
    outerSharedTagsCount = 4 - userTags.length;
  } else if (sharedTags.length < 2) {
    outerUserTagsCount = 4 - sharedTags.length;
  }

  const outerSharedTags = sharedTags.slice(0, outerSharedTagsCount);
  const outerUserTags = userTags.slice(0, outerUserTagsCount);

  const outerSharedUserTags = [...outerSharedTags, ...outerUserTags];

  const outerSystemTags = systemTags.slice(0, 5 - outerSharedUserTags.length);

  const innerSharedTags = sharedTags.slice(outerSharedTagsCount);
  const innerUserTags = userTags.slice(outerUserTagsCount);
  const innerSystemTags = systemTags.slice(outerSystemTags.length);

  return [
    ...outerSharedUserTags,
    ...outerSystemTags,
    ...innerSharedTags,
    ...innerUserTags,
    ...innerSystemTags,
  ];
};
